module.exports = __webpack_public_path__ + "img/upgrade-icon.cf8f3c8d.png";